import { DISPLAY_LANG } from "../../../config";
import axios from "../../../axios";

export const getUserDomains = async () => {
    const reseller_customer_id = localStorage.getItem('reseller_customer_id') ?? '';
    const res = await axios.get(`domain/get_list_domains?customer_id=${reseller_customer_id}`);
    return res.data.results;
};

export const getUserSingleDomains = async (id) => {
    const allDomains = await getUserDomains();
    const singleDomain = allDomains.find(elem => elem.order_id === id);
    const resFullDataDomain = await axios.get(`domain/get_domain_details?order_id=${singleDomain.order_id}`);

    if (resFullDataDomain.data.response.domainname.endsWith('.ru')) {

        const data = resFullDataDomain.data.response.registrantcontact;
        const { ns1, ns2 } = resFullDataDomain.data.response;

        const address = {
            address: data.address1,
            city: data.city,
            country: data.country,
            zip: data.zip,
        }

        return { ...singleDomain, fullData: resFullDataDomain.data.response, address, dns_list: [ns1, ns2] };

    } else {

        const data = resFullDataDomain.data.response.billingcontact;
        const { ns1, ns2 } = resFullDataDomain.data.response;

        const address = {
            address: data.address1,
            city: data.city,
            country: data.country,
            zip: data.zip,
        }

        return { ...singleDomain, fullData: resFullDataDomain.data.response, address, dns_list: [ns1, ns2] };

    }
};

export const getUserDomainPageData = async () => {
    const res = await axios.get(`userspagesdata/user_domain_page`);
    return res.data[0];
};


export const getEditDomainPageData = async () => {
    const res = await axios.get(`userspagesdata/editDomainContactPage?lang=${DISPLAY_LANG}`);
    return res.data[0];
};


// ========================= edit dns ==========================
export const editDnsServers = async (order_id, ns1, ns2) => {
    const body = { order_id, ns1, ns2 };
    const res = await axios.post('domain/modify_name_server', body);
    return res.data;
}


// ========================= edit domain regitrant info ==========================
export const editDomainRegisterInfo = async (body) => {
    const res = await axios.post('/contact/modify_contact_details', body);
    return res.data;
};
